import { newRelic } from '~/utils/newRelic/newRelic';

import {
  type ScanEventProcessor,
  type ScanEventProcessorOptions,
} from '../types/scanEventProcessor.type';
import { createScanEvent } from './createScanEvent.util';

/**
 * Turns queued raw scan events into enriched scan events and hands them to the
 * action handler, one at a time, until the queue is empty.
 */
export const createScanEventProcessor = ({
  getScanContext,
  handleScanEvent,
  queue,
}: ScanEventProcessorOptions): ScanEventProcessor => {
  let isDraining = false;
  let needsDrain = false;

  const process = () => {
    if (isDraining) {
      needsDrain = true;
      return;
    }

    isDraining = true;

    try {
      let rawScanEvent = queue.dequeue();

      while (rawScanEvent) {
        try {
          handleScanEvent(createScanEvent(rawScanEvent, getScanContext()));
        } catch (error) {
          newRelic.noticeError('Failed to process scan event', {
            correlationId: rawScanEvent.correlation_id,
            error,
          });
        }

        rawScanEvent = queue.dequeue();
      }
    } finally {
      isDraining = false;
      if (needsDrain) {
        needsDrain = false;
        process();
      }
    }
  };

  return { process };
};
